export const RepositoryConstants = {
  INTEREST: 'Interest',
  CONVERSATION: 'Conversation',
  TSV: 'TSV',
};
